export default {
  priv: 'pr_device',
  overviewTitle: 'Toestel Types',
  detailTitle: 'Toestel Type',
  deleteTitle: 'dit toestel type',
  url: '/devices/types',
  apiUrl: '/devicetypes/',
  sortBy: ['desc'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'devicetypes',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'desc',
    type: 'text'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'desc',
      link: '/devices/types/{id}',
      width: '90%'
    }
  ],
  newRecord: {
    speeds: []
  }
};
